module.exports = __webpack_public_path__ + "img/8_41.303eff09.png";